import { Header, Root } from './PageSection';

export const PageSection = Object.assign(Root, {
  Header,
});
